import { Address } from "src/services/apiService/response-models";

export const addressToText = (e?: Address) => {
  if (!e)
    return '';
  const parts = [e.addressLine, e.city, e.state];
  return parts.filter(e => !!e).join(',')
}